import React from 'react';
import PropTypes from 'prop-types';
import { imageSet } from '../../../helper/Images';
import Image from '../../../commonComponents/image/Image';

const MakeupItem = ({ makeupHandler, makeupCleared, makeup, item, index }) => {
  const active = makeup === index && !makeupCleared;
  return (
    <li
      className={active ? 'palette--item active' : 'palette--item'}
      onClick={makeupHandler(index)}
    >
      <figure className="palette--item__image-wrapper">
        <figcaption className="palette--item__image-name">
          {item.categoryName}
        </figcaption>
        <Image
          className="palette--item__image-lens"
          src={imageSet[item.type]}
        />
      </figure>
    </li>
  );
};

MakeupItem.propTypes = {
  makeup: PropTypes.number,
  item: PropTypes.shape({
    categoryName: PropTypes.string,
    type: PropTypes.string,
  }),
  makeupCleared: PropTypes.bool,
  makeupHandler: PropTypes.func,
};

export default MakeupItem;
